import { PickListItem } from "@components/picklist/picklist";
import { NFCe } from "@models/nfce/NFCe";
import { NFe } from "@models/NFe";
import { TNFeInfNFeIDENFref, TNFeInfNFeIDENFrefRefECF, TNFeInfNFeIDENFrefRefNF, TNFeInfNFeIDENFrefRefNFP } from "@models/TNFe";
import { formatToCNPJ, formatToCPF } from "brazilian-values";
import { ReactElement } from "react";
import styled from "styled-components";


export const StyledNfRefTable = styled.div<{ listLength: number }>`
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: calc(100vh - 140px);

    overflow: hidden;

    position: relative;

    font-size: .85rem;
    color: #000;

    padding-top: 12px;
    padding-bottom: calc(12px + 10px); //12px from padding value plus 10px for tbody translation

    .header-frame {
        width: calc(100% - 12px);
        height: 30px;
        
        padding: 0 12px;

        display: flex;
        justify-content: space-between;
        
        position: relative;

        input {
            margin-right: 8px;
        }
        
        .header-item-frame {
            height: 100%;
            width: 100%;

            display: flex;

            margin-left: 8px;

            :not(:first-of-type) {
                margin-left: 20px;
            }

            ${({ listLength }) => {
        return listLength > 15 ? `
                            :last-child {
                                margin-right: 12px;
                            }` : '';
    }}

            color: var(--color-darkest);

            transition: opacity .2s ease-in;

            :hover {
                cursor: pointer;
                opacity: 1;
            }

            > i {
                margin: auto 0;
                margin-left: 6px;
                margin-right: 4px;
                font-size: .75rem;
                color: var(--color-primary);
            }

            > span {
                margin: auto 0;
                font-weight: bold;
                white-space: nowrap;
            }
        }
        
        .info-columns-frame {
            display: flex;
            width: calc(100% - 202px);

            overflow: hidden;
            margin-right: auto;

            background-color: #ff00006a;
        }

        .group-selection-btn {
            display: flex;
            align-items: center;
            
            margin-left: -6px;
            padding: 0 0 0 6px;
            
            border: 1px solid var(--grey-light);
            border-radius: 6px;

            cursor: pointer;

            background-color: var(--white);

            :active {
                background-color: var(--grey-lightest);
            }
            
            :focus-visible {
                outline: none;
            }

            i {
                margin-right: 8px;
                font-size: .65rem;
            }
        }
    }

    .list-frame {
        height: calc(100% - 12px);
        max-height: calc(100% - 16px);
        width: calc(100% - 2px); // 100% minus the border width

        margin-top: 6px;

        border: 1px solid var(--grey-light);
        border-radius: 8px;

        background-color: var(--white);

        overflow-y: auto;

        position: relative;

        .row-frame {
            min-height: 30px;

            padding: 2px 4px 2px 12px;

            align-items: center;

            :hover {
                background-color: #edffec;
                cursor: pointer;
            }

            .row-item {
                width: auto;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;

                color: var(--grey-medium);
                
                :not(:first-child) {
                    margin-left: 22px;
                }
                
                :first-child {
                    margin-left: 4px;
                }
            }
            
            input {
                margin-right: 8px;
            }
        }

        .action-frame {
            display: flex;
            height: 100%;
            width: fit-content;

            background-color: transparent;
            border: none;
            margin: 0;
            margin-right: 4px;
            padding: 0;

            &.action-disabled {

                > i {
                    color: var(--grey-light);

                    :hover {
                        color: var(--grey-light) !important;
                        cursor: default !important;
                    }
                }
            }

            :hover {
                cursor: pointer;
            }

            :focus-visible {
                outline: none;
            }
        }

        .actions-frame {
            width: 100%;
            min-width: 120px;
            
            margin-left: 10px;
            
            display: flex;
            justify-content: end
        }

        .loading, .end-message {
            height: 40px;
            display: grid;
            place-items: center;
            color: var(--grey-regular);
        }
    }
`;

export interface NfeTabProps {
    activeNFe: NFe | NFCe
    editMode: boolean
}

export interface TableAction {
    html: ReactElement,
    tooltipText: string,
    callback: (nfRef: CustomTNFeInfNFeIDENFref) => void,
}

export interface CustomTNFeInfNFeIDENFref {
    id: string | null;
    refCTe: string | null;
    refECF: TNFeInfNFeIDENFrefRefECF | null;
    refNF: TNFeInfNFeIDENFrefRefNF | null;
    refNFe: string | null;
    refNFeSig: string | null;
    refNFP: TNFeInfNFeIDENFrefRefNFP | null;
    [property: string]: any;
}

export const refTypesDesc: Record<string, string> = {
    refCTe: 'CT-e',
    refNFe: 'NF-e',
    refNFeSig: 'NF-e (com assinatura)',
    refECF: 'ECF',
    refNF: 'NF',
    refNFP: 'NFP'
};

export const cUFList: PickListItem[] = [
    { id: 2, codigo: '12', value: "AC" },
    { id: 14, codigo: '27', value: "AL" },
    { id: 3, codigo: '13', value: "AM" },
    { id: 6, codigo: '16', value: "AP" },
    { id: 16, codigo: '29', value: "BA" },
    { id: 10, codigo: '23', value: "CE" },
    { id: 27, codigo: '53', value: "DF" },
    { id: 18, codigo: '32', value: "ES" },
    { id: 26, codigo: '52', value: "GO" },
    { id: 8, codigo: '21', value: "MA" },
    { id: 17, codigo: '31', value: "MG" },
    { id: 24, codigo: '50', value: "MS" },
    { id: 25, codigo: '51', value: "MT" },
    { id: 5, codigo: '15', value: "PA" },
    { id: 12, codigo: '25', value: "PB" },
    { id: 13, codigo: '26', value: "PE" },
    { id: 9, codigo: '22', value: "PI" },
    { id: 21, codigo: '41', value: "PR" },
    { id: 19, codigo: '33', value: "RJ" },
    { id: 1, codigo: '11', value: "RO" },
    { id: 4, codigo: '14', value: "RR" },
    { id: 11, codigo: '24', value: "RN" },
    { id: 23, codigo: '43', value: "RS" },
    { id: 22, codigo: '42', value: "SC" },
    { id: 15, codigo: '28', value: "SE" },
    { id: 20, codigo: '35', value: "SP" },
    { id: 7, codigo: '17', value: "TO" }
];

export const refTypes: PickListItem[] = [
    { id: 1, value: "NF-e", codigo: "refNFe" },
    { id: 2, value: "NF-e (com assinatura)", codigo: "refNFeSig" },
    { id: 3, value: "CT-e", codigo: "refCTe" },
    { id: 4, value: "ECF", codigo: "refECF" },
    { id: 5, value: "NF", codigo: "refNF" },
    { id: 6, value: "NFP", codigo: "refNFP" }
];

export const defColumns = [
    { header: 'Id', accessor: 'id', isActive: false, minWidth: 0 },
    {
        header: 'Tipo de Referência', accessor: 'type', isActive: true, minWidth: 165, customView: (value: any) => (
            <span style={{
                minWidth: "140px",
                display: 'inline-block',
                padding: '0.35em 0.65em',
                fontSize: '0.8rem',
                fontWeight: 700,
                lineHeight: 1,
                textAlign: 'center',
                whiteSpace: 'nowrap',
                verticalAlign: 'baseline',
                borderRadius: '0.375rem',
                color: '#fff',
                backgroundColor: '#058237'
            }}>
                {getRefType(value)}
            </span>
        )
    },
    { header: 'Descrição', accessor: 'description', isActive: true, minWidth: 310 }
]

export const getNfRefTypeKey = (object: TNFeInfNFeIDENFref | CustomTNFeInfNFeIDENFref) => {
    const [key, val] = Object.entries(object).find(([key, val]) => key !== 'id' && val !== null) || [];
    return key;
}

export const getNfRefTypeItem = (object: TNFeInfNFeIDENFref | CustomTNFeInfNFeIDENFref) => {
    const key = getNfRefTypeKey(object)
    return refTypes.find(types => types.codigo === key);
}

export const getRefType = (object: TNFeInfNFeIDENFref) => {
    const key = getNfRefTypeKey(object);
    return (!!key && refTypesDesc[key]) ?? 'Referência desconhecida';
}

export const defaultCustomNFref: CustomTNFeInfNFeIDENFref = { id: null, refCTe: null, refNFe: null, refNFeSig: null, refNFP: null, refECF: null, refNF: null };

export const defineColValue = (value) => {

    const rowStyle = { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "1rem" };

    const key = getNfRefTypeKey(value);

    switch (key) {
        case "refCTe":
            value = <div><strong>Chave CT-e:</strong> {value.refCTe}</div>;
            break;
        case "refNFe":
            value = <div><strong>Chave NF-e:</strong> {value.refNFe}</div>;
            break;
        case "refNFeSig":
            value = <div><strong>Referência NF-e (com assinatura):</strong> {value.refNFeSig}</div>;
            break;
        case "refECF":
            const refECF = value.refECF;
            value = <div style={rowStyle}>
                {refECF.mod && <div><strong>Código do modelo do Documento Fiscal:</strong> {refECF.mod}</div>}
                {refECF.ncoo && <div><strong>Número do Contador de Ordem de Operação:</strong> {refECF.ncoo}</div>}
                {refECF.necf && <div><strong>Número de ordem sequencial do ECF:</strong> {refECF.necf}</div>}
            </div>
            break;
        case "refNF":
            const refNf = value.refNF;
            value = <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                <div style={rowStyle}>
                    {refNf.aamm && <div><strong>AAMM da emissão da NF:</strong> {refNf.aamm}</div>}
                    {refNf.cuf && <div><strong>UF do emitente:</strong> {refNf.cuf} - {cUFList.find(cuf => cuf.value === refNf.cuf)?.codigo}</div>}
                    {refNf.cnpj && <div><strong>CNPJ:</strong> {formatToCNPJ(refNf.cnpj)}</div>}
                </div>
                <div style={rowStyle}>
                    {refNf.mod && <div><strong>Código do modelo do Documento Fiscal:</strong> {refNf.mod}</div>}
                    {refNf.nnf && <div><strong>Número do Documento Fiscal:</strong> {refNf.nnf}</div>}
                    {refNf.serie && <div><span><strong>Série:</strong> {refNf.serie}</span></div>}
                </div>
            </div>
            break;
        case "refNFP":
            const refNFP = value.refNFP;
            value = <div style={{ display: "flex", flexDirection: "column", gap: "0.2rem" }}>
                <div style={rowStyle}>
                    {refNFP.aamm && <div><strong>AAMM da emissão da NF de produtor:</strong> {refNFP.aamm}</div>}
                    {refNFP.cuf && <div><strong>UF do emitente:</strong> {refNFP.cuf} - {cUFList.find(cuf => cuf.value === refNFP.cuf)?.codigo}</div>}
                </div>
                <div style={rowStyle}>
                    {refNFP.cnpj && <div><strong>CNPJ:</strong> {formatToCNPJ(refNFP.cnpj)}</div>}
                    {refNFP.cpf && <div><strong>CPF:</strong> {formatToCPF(refNFP.cpf)}</div>}
                    {refNFP.ie && <div><strong>IE do emitente da NF de Produtor:</strong> {refNFP.ie}</div>}
                </div>
                <div style={rowStyle}>
                    {refNFP.mod && <div><strong>Código do modelo do Documento Fiscal:</strong> {refNFP.mod}</div>}
                    {refNFP.nnf && <div><strong>Número do Documento Fiscal:</strong> {refNFP.nnf}</div>}
                    {refNFP.serie && <div><span><strong>Série:</strong> {refNFP.serie}</span></div>}
                </div>
            </div>
            break;
        default:
            value = 'N/A';
    }

    return value;
}